import React from "react";
import { Outlet } from "react-router-dom";

import TopHeaderBusiness from "../../../../../components/general/TopHeaderBusiness";
import ControllingGroupData from "./controllingGroupData/ControllingGroupData";

const ControllingGroupBusiness = () => {
    return (
        <>
            <TopHeaderBusiness />
            <div className="row">
                <div className="col-md-12">
                    <ControllingGroupData/>
                </div>
                <div className="col-md-12">
                    <Outlet />
                </div>
            </div>

        </>

    );
};

export default ControllingGroupBusiness;